import { Navigate } from "react-router-dom";

import { useActivePurchaseAccess } from "../../hooks/useActivePurchaseAccess";
import { FORM_IDS, PROCESS_IDS } from "../../lib/permissionCatalog";
import { hasPermission } from "../../lib/permissions";
import { canManageProjects } from "../../lib/purchaseAccess";

export function LegacyProjectBudgetCreateRedirect({ budgetListPath }: { budgetListPath: string }) {
  const { user } = useActivePurchaseAccess();
  if (canManageProjects(user)) return <Navigate to="/projects/create" replace />;
  if (hasPermission(user, { forms: [FORM_IDS.PROJECTS], processes: [PROCESS_IDS.PROJECT_VIEW] })) {
    return <Navigate to="/projects" replace />;
  }
  return <Navigate to={budgetListPath} replace />;
}
